export default {
  pages: {
    key: "title",
    data: [
      {title: 'Inicio',   url: '/',      icon: 'FileIcon', is_bookmarked: false},
      {title: 'Page 2', url: '/page2', icon: 'FileIcon', is_bookmarked: false}
    ]
  }
}
